var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 0H7.33327C5.48327 0 3.99993 1.48333 3.99993 3.33333V13.0333C4.96362 12.0979 6.0943 11.3517 7.33327 10.8333V3.33333H18.9999V13.0333C19.0499 13.0833 19.1166 13.1167 19.1666 13.1667C19.7333 13.7333 20.2166 14.35 20.6166 15H30.6666V26.6667H20.6166C20.2166 27.3167 19.7333 27.9333 19.1666 28.5C18.5666 29.0833 17.9166 29.5667 17.2333 30H30.6666C32.5166 30 33.9999 28.5167 33.9999 26.6667V10L23.9999 0ZM22.3333 11.6667V2.5L31.4999 11.6667H22.3333ZM11.4999 13.3333C7.33327 13.3333 3.99993 16.6667 3.99993 20.8333C3.99993 22.3 4.4166 23.6833 5.14993 24.8333L0.0166016 30L2.33327 32.3167L7.53327 27.2C8.68327 27.9167 10.0499 28.3333 11.4999 28.3333C15.6666 28.3333 18.9999 25 18.9999 20.8333C18.9999 16.6667 15.6666 13.3333 11.4999 13.3333ZM11.4999 25C10.3949 25 9.33506 24.561 8.55366 23.7796C7.77225 22.9982 7.33327 21.9384 7.33327 20.8333C7.33327 19.7283 7.77225 18.6685 8.55366 17.8871C9.33506 17.1057 10.3949 16.6667 11.4999 16.6667C12.605 16.6667 13.6648 17.1057 14.4462 17.8871C15.2276 18.6685 15.6666 19.7283 15.6666 20.8333C15.6666 21.9384 15.2276 22.9982 14.4462 23.7796C13.6648 24.561 12.605 25 11.4999 25Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.b6fcb1a3fea3ea5bc52be4d75c5c5bd7.svg";
export { ForwardRef as ReactComponent };